
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/community/showcase",
      function () {
        return require("private-next-pages/community/showcase.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/community/showcase"])
      });
    }
  